import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { AuthProvider } from './context/AuthProvider'
import { Provider } from 'react-redux'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import store from './store/store'
import './assets/scss/sfy-cms.scss'
import {
    MainFullPreloader,
    TopBarPreloader,
} from './components/layout/preloaders/SamirifyPreloaders'
import Common from './components/common/Common'
import { ToastContainer } from 'react-toastify'
// import { PrimeReactProvider } from 'primereact/api'
import '@fortawesome/fontawesome-free'
import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(far, fas, fab)

const root = createRoot(document.getElementById('samirify-cms') as HTMLElement)

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <Common.ToastProvider>
                <TopBarPreloader />
                <MainFullPreloader />
                <BrowserRouter>
                    <AuthProvider>
                        <Routes>
                            <Route path="/*" element={<App />} />
                        </Routes>
                    </AuthProvider>
                </BrowserRouter>
                <ToastContainer />
            </Common.ToastProvider>
        </Provider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
